import { makeStyles } from "@material-ui/core/styles";
import React, { FC, KeyboardEvent, useState } from "react";
import { WrappedComponentProps, injectIntl } from "react-intl";
import ContractCheckboxes from "./ContractCheckboxes";
import ContractSignatureControl from "./ContractSignatureControl";
import ContractText from "./ContractText";
import { DialogTitle, Box } from "@material-ui/core";
import { MyDialog } from "../../Ui/MyDialog";
import { CustomButton } from "../../Ui/CustomButton";
import { useToastNotifications } from "../../../utils/toastUtils";

const useStyles = makeStyles((theme) => ({
  contractContainer: {
    height: "100%",
    maxHeight: "100%",
    overflow: "auto",
    border: "1px solid lightgrey",
    borderRadius: 5,
    padding: theme.spacing(1),
  },
  button: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: theme.spacing(2, 0),
  },
}));

interface ContractPropsInterface {
  open: boolean;
  contractTemplate: string;
  title: string;
  handleClose(): void;
  handleSendSignature(signatureData: string): void;
  loading?: boolean;
}

const Contract: FC<ContractPropsInterface & WrappedComponentProps> = (
  props,
) => {
  const {
    open,
    contractTemplate,
    handleClose,
    contractTemplate: template, // alias, si besoin
    title,
    handleSendSignature,
    loading,
    intl,
  } = props;
  const [signatureDataUrl, setSignatureDataUrl] = useState("");
  const [isCertified, setIsCertified] = useState(false);
  const [isEngaged, setIsEngaged] = useState(false);
  const classes = useStyles();
  const { showErrorToast } = useToastNotifications();

  const handleUploadSignature = (fileDataUrl: string) => {
    setSignatureDataUrl(fileDataUrl);
  };

  const handleSaveSignature = (signatureDataUrl: string) => {
    setSignatureDataUrl(signatureDataUrl);
  };

  const snackbarFieldsControl = (messageId: string) => {
    showErrorToast({ description: messageId });
  };
  const [isSubmitted, setIsSubmitted] = useState(false);
  const sendSignature = () => {
    setIsSubmitted(true);
    if (!isCertified) {
      return snackbarFieldsControl("contract.error.certifyPersonInfo");
    }
    if (!isEngaged) {
      return snackbarFieldsControl("contract.error.engagement");
    }
    if (!signatureDataUrl) {
      return snackbarFieldsControl("contract.error.notSigned");
    }
    handleSendSignature(signatureDataUrl);
  };

  const handleKeyPress = (event: KeyboardEvent<HTMLFormElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      sendSignature();
    }
  };

  const handleEngagementChecked = () => {
    setIsEngaged(!isEngaged);
  };

  const handleCertificationChecked = () => {
    setIsCertified(!isCertified);
  };

  const handleCloseModal = () => {
    if (loading) return;
    handleClose();
  };

  return (
    <MyDialog
      open={open}
      onClose={handleCloseModal}
      fullWidth
      maxWidth="md"
      dialogTitle={
        <DialogTitle>
          {intl.formatMessage({ id: "contract.title" })}
        </DialogTitle>
      }
    >
      <ContractText
        contractTemplate={contractTemplate}
        className={classes.contractContainer}
      />

      <ContractCheckboxes
        isEngaged={isEngaged}
        isCertified={isCertified}
        handleEngagementChecked={handleEngagementChecked}
        handleCertificationChecked={handleCertificationChecked}
        isSubmitted={isSubmitted}
      />

      <form onKeyPress={handleKeyPress}>
        <ContractSignatureControl
          handleUploadSignature={handleUploadSignature}
          signatureImage={signatureDataUrl}
          handleSaveSignature={handleSaveSignature}
          disabled={loading}
          title={title}
        />
      </form>

      <Box className={classes.button}>
        <CustomButton
          type="button"
          variant="primary"
          onClick={sendSignature}
          label="save"
          loading={loading}
          fullWidthMobile
        />
      </Box>
    </MyDialog>
  );
};

export default injectIntl(Contract);
